export default "__VITE_ASSET__CTJSZVRD__"